import React from 'react';
import './style.css';
import {useRecoilValue} from 'recoil';
import {informationAtom} from '../../store/InformationStore';
import {connectionErrorAtom} from '../../store/ConnectionErrorStore';
import TimeLine from './timeline/TimeLine';
import {useLocation} from 'react-router-dom';

const InformationTab = (props) => {
    const information = useRecoilValue(informationAtom);
    const connectionError = useRecoilValue(connectionErrorAtom);
    const location = useLocation();
    const rightPanelLang = props?.rightPanelLang || 'tr';

    const renderPageEn = () => {
        const Dot = ({children}) => (
            <div className="information-tab-li-dot">
                <span/>{children}
            </div>
        );

        if (location.pathname === '/simulation') {
            return (
                <div className="information-tab-root">
                    <TimeLine rightPanelLang={rightPanelLang}/>
                </div>
            );
        }

        if (connectionError) {
            return (
                <div className="information-tab-root">
                    <div className="information-tab-li">
                        <span className="information-tab-dot"></span>This screen may appear automatically on top of any
                        page. While it is visible, the user cannot perform actions on the portal.
                    </div>
                    <Dot>
                        Main reasons for this screen:
                        <div>Issues originating from the aircraft antenna</div>
                        <div>Connection loss between ground and aircraft</div>
                        <div>Ground system failure</div>
                        <div>Cabin doors not yet closed</div>
                    </Dot>
                    <Dot>
                        If authorized, you can visit the address below to inspect root causes:
                        <div>https://www.tkwifi.net/#/diag</div>
                    </Dot>
                    <Dot>
                        To display this error screen on any page, use <b className="red">Trigger Error</b> on the
                        lower-left
                        of this panel. Use <b className="green">Close Error</b> to hide it.
                    </Dot>
                </div>
            );
        }

        if (information.type === 'first_screen') {
            return (
                <div className="information-tab-root">
                    <Dot>After enabling flight mode, connect to <b className="red">TK WiFi</b> from device Wi-Fi
                        settings.</Dot>
                    <Dot>If redirect does not happen automatically, open a browser and type <b
                        className="green">https://www.tkwifi.net</b>.</Dot>
                    <Dot>
                        If access fails, confirm the exact address. The following are invalid:
                        <div>https://tkwifi.net</div>
                        <div>http://tkwifi.net</div>
                        <div>http://www.tkwifi.net</div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'flightInformationType_1' || information.type === 'login_type_1') {
            return (
                <div className="information-tab-root">
                    <Dot>If redirect does not happen after Wi-Fi connection, open browser and type <b
                        className="green">https://www.tkwifi.net</b>. Using <b className="red">http://</b> causes an
                        error.</Dot>
                    <Dot>
                        For flight-information login, surname and seat number must match the ticket.
                        <div>Successful login sample: Surname "AHMAD", Seat "1A".</div>
                        <div>No-package user sample: Surname "DENEME", Seat "2A".</div>
                    </Dot>
                    <Dot>
                        The most common error is surname misspelling. Entering <b className="red">AHMAT</b> instead of
                        <b className="green"> AHMAD</b> fails.
                        <div>You can enter random values for failed-login testing.</div>
                    </Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'flightInformationType_2') {
            return (
                <div className="information-tab-root">
                    <Dot>If redirect does not happen after Wi-Fi connection, open browser and type <b
                        className="green">https://www.tkwifi.net</b>. Using <b className="red">http://</b> causes an
                        error.</Dot>
                    <Dot>
                        Passengers can also login with ticket number. Ticket number must exactly match the ticket.
                        <div>Successful sample: <b className="green">1234567890123</b>.</div>
                    </Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'login_type_2') {
            return (
                <div className="information-tab-root">
                    <Dot>
                        Passenger can login with Miles&Smiles using different methods:
                        <div>Miles&Smiles membership number</div>
                        <div>Email address</div>
                    </Dot>
                    <Dot>
                        TTNET End User Agreement must be approved.
                        <div>Auto-process miles option is <b className="red">not mandatory</b>.</div>
                    </Dot>
                    <Dot>If passenger forgot password, use <b className="red">"Forgot Password"</b>.</Dot>
                    <Dot>
                        Successful test credentials:<br/>Password:<b className="red"> 111111</b>
                        <div>Miles&Smiles membership number:<b> TK123456789</b></div>
                        <div>Email:<b> deneme@test.com</b></div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'login_type_3') {
            return (
                <div className="information-tab-root">
                    <Dot>If needed, connection can be established via the <b className="red">Turkish Airlines mobile
                        app</b>.</Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'login_type_4') {
            return (
                <div className="information-tab-root">
                    <Dot>Promotion code login supports seat number or ticket number. Username/password must match the
                        card details.</Dot>
                    <Dot>
                        Successful test values:
                        <div>Surname:<b>DENEME</b></div>
                        <div>Seat Number:<b>1A</b></div>
                        <div>Promotion Code:<b>123456</b></div>
                    </Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'login_type_5') {
            return (
                <div className="information-tab-root">
                    <Dot>
                        Promotion code login supports:
                        <div>Seat number or ticket number</div>
                        <div>Free Wi-Fi access via promotion code</div>
                        <div>Credentials must match card details</div>
                    </Dot>
                    <Dot>
                        Successful test values:
                        <div>Ticket Number:<b>1234567890123</b></div>
                        <div>Promotion Code:<b>123456</b></div>
                    </Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'login_type_6') {
            return (
                <div className="information-tab-root">
                    <Dot>User can login with username and password.</Dot>
                    <Dot>
                        Successful test values:
                        <div>Username:<b>Deneme</b></div>
                        <div>Password:<b>123456</b></div>
                    </Dot>
                    <Dot>Passenger must approve the TTNET End User Agreement.</Dot>
                </div>
            );
        }

        if (information.type === 'forget_password') {
            return (
                <div className="information-tab-root">
                    <Dot>Forgot-password method allows quick re-login.</Dot>
                    <Dot>Passenger can access Miles&Smiles via <b className="red">seat number</b> or <b className="red">ticket
                        number</b>.</Dot>
                    <Dot>
                        TTNET End User Agreement must be approved.
                        <div>Auto-process miles option is <b className="red">not mandatory</b>.</div>
                    </Dot>
                    <Dot>
                        Successful test values:
                        <div>Miles&Smiles membership number:<b> TK123456789</b></div>
                        <p>-----</p>
                        <div>Seat Number:<b> 1A</b></div>
                        <p>or</p>
                        <div>Ticket Number:<b> 1234567890123</b></div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'register_miles_smiles') {
            return (
                <div className="information-tab-root">
                    <Dot>Passenger can create a Miles&Smiles membership during the flight.</Dot>
                    <Dot>When logging in with seat details, name/surname/gender/nationality/birth date are auto-filled
                        from ticket if available.</Dot>
                    <Dot>All fields must be filled <b className="red">completely</b>.</Dot>
                    <Dot>All <b className="red">terms and conditions</b> must be accepted.</Dot>
                </div>
            );
        }

        if (information.type === 'internet_packages') {
            return (
                <div className="information-tab-root">
                    <Dot>Passengers can view <b className="red">Paid Internet Packages</b> on this page.</Dot>
                    <Dot>
                        For international and ER flights, passengers can purchase packages or use assigned rights.
                        <div className="information-tab-free-table">
                            <div className="information-tab-free-table-title">PAID PACKAGES (INTERNATIONAL and ER)</div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Quota</th>
                                    <th>Price</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Unlimited messaging</td>
                                    <td>3 USD</td>
                                </tr>
                                <tr>
                                    <td>250 MB internet</td>
                                    <td>9 USD</td>
                                </tr>
                                <tr>
                                    <td>500 MB internet</td>
                                    <td>15 USD</td>
                                </tr>
                                <tr>
                                    <td>1 GB internet</td>
                                    <td>20 USD</td>
                                </tr>
                                <tr>
                                    <td>Unlimited internet and messaging</td>
                                    <td>25 USD</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Dot>
                    <Dot>
                        For domestic flights, passengers can purchase packages or use assigned rights.
                        <div className="information-tab-free-table">
                            <div className="information-tab-free-table-title">PAID PACKAGES (DOMESTIC)</div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Quota</th>
                                    <th>Price</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>Unlimited messaging package (except YC M&amp;S members and BC passengers)</td>
                                    <td>150 TL</td>
                                </tr>
                                <tr>
                                    <td>Unlimited internet package (BC and all YC passengers)</td>
                                    <td>350 TL</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'free_internet_rights') {
            return (
                <div className="information-tab-root">
                    <Dot>Passengers can view <b className="red">Free Internet Packages</b> on this page.</Dot>
                    <Dot>
                        For international and ER flights, passengers can use automatically assigned rights.
                        <div className="information-tab-free-table">
                            <div className="information-tab-free-table-title">FREE PACKAGES (INTERNATIONAL and ER)</div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Package Description</th>
                                    <th>Quota</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>BC Miles&amp;Smiles Elite and Elite Plus</td>
                                    <td>Unlimited Internet</td>
                                </tr>
                                <tr>
                                    <td>Other BC (except Elite and Elite Plus)</td>
                                    <td>1 GB internet + unlimited messaging</td>
                                </tr>
                                <tr>
                                    <td>YC Miles&amp;Smiles Elite and Elite Plus</td>
                                    <td>400 MB + unlimited messaging</td>
                                </tr>
                                <tr>
                                    <td>YC Miles&amp;Smiles Classic Plus</td>
                                    <td>250 MB + unlimited messaging</td>
                                </tr>
                                <tr>
                                    <td>YC Miles&amp;Smiles Classic</td>
                                    <td>Unlimited messaging</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Dot>
                    <Dot>
                        For domestic flights, passengers can use automatically assigned rights.
                        <div className="information-tab-free-table">
                            <div className="information-tab-free-table-title">FREE PACKAGES (DOMESTIC)</div>
                            <table>
                                <thead>
                                <tr>
                                    <th>Package Description</th>
                                    <th>Quota</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>BC</td>
                                    <td>Unlimited messaging</td>
                                </tr>
                                <tr>
                                    <td>YC Miles&amp;Smiles</td>
                                    <td>Unlimited messaging</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </Dot>
                </div>
            );
        }

        //Feedback ekranına girildiğinde
        if (information.type === 'feedback')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Passengers can share their internet experiences and complaints from this page.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/> Areas you can respond to
                            <div>How did you find our in-flight internet service?</div>
                            <div>How would you rate the process of connecting to the internet?</div>
                            <div>How would you rate the process of registering and connecting to our in-flight internet
                                service?
                            </div>
                            <div>You can share your comments or suggestions regarding our in-flight internet service.
                            </div>
                        </div>
                    </div>
                </>);

        if (information.type === 'remaining_usage_1') {
            return (
                <div className="information-tab-root">
                    <Dot>This is the first page shown after successful login.</Dot>
                    <Dot>
                        On this page passenger can:
                        <div>View purchased packages</div>
                        <div>Stop or resume internet</div>
                        <div>Log out</div>
                    </Dot>
                    <Dot>When passenger clicks <b className="red">'Stop connection'</b>, package usage pauses and
                        internet access stops.</Dot>
                    <Dot>When passenger clicks <b className="red">'Resume connection'</b>, package usage
                        continues.</Dot>
                    <Dot>If the page is closed without logout and passenger revisits <b>https://www.tkwifi.net</b>, this
                        page opens automatically.</Dot>
                </div>
            );
        }

        if (information.type === 'remaining_usage_0') {
            return (
                <div className="information-tab-root">
                    <Dot>If the passenger has <b className="red">no package</b>, this screen appears.</Dot>
                    <Dot>Passenger can proceed to <b className="red">buy internet package</b> or <b className="red">log
                        out</b>.</Dot>
                    <Dot>If the page is closed without logout and passenger revisits <b>https://www.tkwifi.net</b>, this
                        page opens automatically.</Dot>
                </div>
            );
        }

        if (information.type === 'purchase_package') {
            return (
                <div className="information-tab-root">
                    <Dot>Passenger can purchase one of the available domestic/international packages.</Dot>
                    <Dot>Payments are made in <b className="green">TL</b> for domestic flights and <b
                        className="green">USD</b> for international flights.</Dot>
                    <Dot>Passenger can also pay with <b className="red">miles</b>.</Dot>
                </div>
            );
        }

        if (information.type === 'payment_credit_card') {
            return (
                <div className="information-tab-root">
                    <Dot>
                        Two payment methods are available:
                        <div>Credit/Debit card payment</div>
                        <div>Pay with miles</div>
                    </Dot>
                    <Dot>Passenger can buy internet package with card details. Card data must be <b className="red">complete
                        and accurate</b>.</Dot>
                    <Dot>Invoice email must be valid. Purchase cannot continue without approving distance sales and
                        pre-information forms.</Dot>
                    <Dot>
                        <b className="red">Successful</b> payment test values:
                        <div>Name Surname: <b>Deneme Test</b></div>
                        <div>Card Number:<b> 1234 1234 1234 1234</b></div>
                        <div>Date: <b>09/36</b></div>
                        <div>CVC: <b>123</b></div>
                        <div>Email: <b>deneme@test.com</b></div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'payment_mil') {
            return (
                <div className="information-tab-root">
                    <Dot>
                        Two payment methods are available:
                        <div>Credit/Debit card payment</div>
                        <div>Pay with miles</div>
                    </Dot>
                    <Dot>Passenger can pay with accumulated miles. Miles&Smiles credentials must be entered <b
                        className="red">without errors</b>.</Dot>
                    <Dot>Purchase cannot continue without approving distance sales and pre-information forms.</Dot>
                    <Dot>
                        <b className="red">Successful</b> payment test values:
                        <div>Miles&Smiles membership number: <b>TK | 123456789</b></div>
                        <div>Password:<b> 123456</b></div>
                    </Dot>
                </div>
            );
        }

        if (information.type === 'payment_mil_ok') {
            return (
                <div className="information-tab-root">
                    <Dot>
                        Two payment methods are available:
                        <div>Credit/Debit card payment</div>
                        <div>Pay with miles</div>
                    </Dot>
                    <Dot>Passenger can pay with accumulated miles.</Dot>
                    <Dot>Since user is already logged in via Miles&Smiles, additional Miles&Smiles login is not
                        required.</Dot>
                    <Dot>Purchase cannot continue without approving distance sales and pre-information forms.</Dot>
                </div>
            );
        }

        return <></>;
    };

    const renderPage = () => {

        if (rightPanelLang === 'en') return renderPageEn();

        //Simulation
        if (location.pathname === '/simulation')
            return (
                <>
                    <div className="information-tab-root">
                        <TimeLine rightPanelLang={rightPanelLang}/>
                    </div>
                </>);


        //Internet hatası alındığında gösterilecek INFO bilgisi
        if (connectionError)
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li">
                            <span className="information-tab-dot"></span>Bu ekran otomatik olarak herhangi bir ekran
                            üzerinde gelebilmektedir. Bu ekran gözüktüğünde kullanıcı portal üzerinde herhangi bir
                            aksiyonda bulunamamaktadır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Bu ekranın gelme nedenleri
                            <div>Uçaktaki antenden kaynaklanan sorunlar nedeniyle</div>
                            <div>Yer ile uçak arasında bağlantı kesildiğinde</div>
                            <div>Yer sisteminde herhangi bir arıza yaşandığında</div>
                            <div>Henüz kapılar kapanmamış olma durumunda</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Problemin neden kaynaklandığını görüntülemek için yetkiniz dahilinde aşağıdaki adresi
                            ziyaret edebilirsiniz.
                            <div>https://www.tkwifi.net/#/diag</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Herhangi bir sayfada hata ekranını görüntülemek için bu panelin sol alt köşesinde
                            bulunan <b className="red">Hata Çıkar</b> butonunu kullanabilirsiniz. Aynı şekilde hatayı
                            kapatmak için <b className="green">Hata Kapat</b> butonunu kullanabilirsiniz.
                        </div>
                    </div>
                </>);

        //İlk loading ekranı
        if (information.type === 'first_screen')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu uçak içerisinde cihazını uçuş moduna aldıktan sonra kablosuz ağ özelliğinden <b
                            className="red"> TK WiFi</b> ile bağlantı sağlanır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>WiFi bağlantısı yapıldıktan sonra yönlendirme olmazsa, internet tarayıcısı açılır ve
                            adres bölümüne<b className="green"> https://www.tkwifi.net</b> yazılır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Sayfaya erişim sağlanamazsa adres çubuğunda doğru adresin yazıldığına emin olun.
                            Aşağıdaki adresler yanlış adreslerdir.
                            <div>https://tkwifi.net</div>
                            <div>http://tkwifi.net</div>
                            <div>http://www.tkwifi.net</div>
                        </div>
                    </div>
                </>);

        //İlk giriş ekranındaki Koltuk numarası ile giriş
        if (information.type === 'flightInformationType_1' || information.type === 'login_type_1')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>WiFi bağlantısı yapıldıktan sonra yönlendirme olmazsa, internet tarayıcısı açılır ve
                            adres bölümüne<b className="green"> https://www.tkwifi.net</b> yazılır.<br/><b
                            className="red"> http://</b> olarak yazılması durumunda hata alınır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu uçuş bilgileri ile giriş yapmak
                            istediğinde mutlaka soyad ve koltuk numarası bilet üzerinde olan bilgiler olmalıdır.
                            <div>Doğru bilgiler ile giriş için Soyad "AHMAD", koltuk "1A" girişi yapabilirsiniz.</div>
                            <div>Herhangi bir paketi olmayan kullanıcı ile giriş yapmak için Soyad "DENEME", koltuk "2A"
                                girişi yapabilirsiniz.
                            </div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu bilgilerinde <b>en çok yapılan hata soyad yazılışlarında</b> olmaktadır. Burada
                            yolcu soyadı <b className="green">AHMAD</b> yerine<b className="red"> AHMAT</b> yazılırsa bu
                            şekilde hata vermektedir.
                            <div>Yanlış giriş testi için rastgele bir değer girebilirsiniz.</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //İlk giriş ekranındaki Bilet numarası ile giriş
        if (information.type === 'flightInformationType_2')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>WiFi bağlantısı yapıldıktan sonra yönlendirme olmazsa, internet tarayıcısı açılır ve
                            adres bölümüne<b className="green"> https://www.tkwifi.net</b> yazılır.<br/><b
                            className="red"> http://</b> olarak yazılması durumunda hata alınır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu bir diğer giriş yöntemi olan bilet numarası ile sisteme giriş yapabilir. Yine
                            burada mutlaka bilet üzerinde yazan<b className="red"> bilet numarası</b> yazılmalıdır.
                            <div>Doğru bilgiler ile giriş için<b className="green">1234567890123</b>giriş
                                yapabilirsiniz.
                            </div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //miles&smiles ile giriş
        if (information.type === 'login_type_2')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu Miles and Smiles üyeliği ile sisteme
                            giriş yapabilir. Burada birçok farklı yöntem ile yolcu giriş yapabilmektedir.
                            <div>Miles&Smiles üyelik numarası</div>
                            <div>E-Posta adresi</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                            <div>Millerini otomatik işlenmesi seçeneği <b className="red">zorunlu değildir</b>.</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu şifresini unutursa <b className="red">"Şifremi unuttum"</b> kısmından giriş
                            yapabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/> Başarılı giriş denemeleri için aşağıdaki bilgileri kullanabilirsiniz.<br/>Şifre:<b
                            className="red"> 111111</b>
                            <div>Miles&Smiles üyelik numarası:<b> TK123456789</b></div>
                            <div>E-Posta adresi:<b> deneme@test.com</b></div>
                        </div>
                    </div>
                </>);

        //thy app girişi
        if (information.type === 'login_type_3')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>İstenirse <b className="red">Türk Hava Yolları mobil uygulaması</b> ile bağlantı
                            sağlanabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //Promotion girişi - Koltuk Numarası ile
        if (information.type === 'login_type_4')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Promosyon kod ile girişte iki seçenek bulunur. Koltuk numarası ya da bilet numarası.
                            Promosyon kodu ile ücretsiz wifi kullanımı sağlanır. Kullanıcı adı ve şifre kart üzerinde
                            yer alan bilgilerle giriş yapılmalıdır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Başarılı giriş denemeleri için aşağıdaki bilgileri kullanabilirsiniz.
                            <div>Soyad:<b>DENEME</b></div>
                            <div>Koltuk numarası:<b>1A</b></div>
                            <div>Promosyon kodu:<b>123456</b></div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //Promotion girişi - Bilet Numarası ile
        if (information.type === 'login_type_5')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Promosyon kod ile girişte iki seçenek bulunur.<br/>Koltuk numarası ya da bilet
                            numarası;
                            <div>Promosyon kodu ile ücretsiz wifi kullanımı sağlanır.</div>
                            <div>Kullanıcı adı ve şifre kart üzerinde yer alan bilgilerle giriş yapılmalıdır.</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Başarılı giriş denemeleri için aşağıdaki bilgileri kullanabilirsiniz.
                            <div>Bilet numarası:<b>1234567890123</b>
                            </div>
                            <div>Promosyon kodu:<b>123456</b></div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //Kullanıcı adı ve Şifre ile giriş
        if (information.type === 'login_type_6')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Kullanıcı adı ve şifre ile giriş yapılabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Başarılı giriş denemeleri için aşağıdaki bilgileri kullanabilirsiniz.
                            <div>Kullanıcı Adı:<b>Deneme</b></div>
                            <div>Şifre:<b>123456</b></div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                        </div>
                    </div>
                </>);

        //Şifremi unuttum ekranı
        if (information.type === 'forget_password')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Burada şifremi unuttum yöntemi ile basitçe tekrardan sisteme giriş sağlanabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Şifremi unuttum bölümünde <b className="red">yolcu koltuk numarası</b> ya da <b
                            className="red">bilet numarası</b> ile Miles and Smiles üyeliğinde kolayca erişim
                            sağlayabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu mutlaka TTNET Son Kullanıcı Sözleşmesi'ni onaylamalıdır.
                            <div>Millerini otomatik işlenmesi seçeneği <b className="red">zorunlu değildir</b>.</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span className="information-tab-dot"></span>Başarılı giriş denemeleri için aşağıdaki
                            bilgileri kullanabilirsiniz.
                            <div>Miles&Smiles üyelik numarası:<b> TK123456789</b></div>
                            <p>-----</p>
                            <div>Koltuk numarası:<b> 1A</b></div>
                            <p>veya</p>
                            <div>Bilet numarası:<b> 1234567890123</b></div>
                        </div>
                    </div>
                </>);

        //Miles&Smiles üyelik ekranı
        if (information.type === 'register_miles_smiles')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Bu sayfada yolcu uçak içerisinde Miles and Smiles üyeliği oluşturabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu koltuk bilgileri ile giriş yaparak Miles and Smiles üyeliği oluşturmak isterse
                            bilet üzerinde yer alan Ad, Soyad, Cinsiyet, Uyruk, Doğum tarihi bilgileri otomatik olarak
                            dolu gelir. Eksik bilgi var ise yolcu tamamlayabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Bütün alanların<b className="red"> eksiksiz</b> şekilde doldurulması gerekmektedir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Tüm <b className="red">sözleşme genel kurallar ve koşulların</b> kabul edilmesi
                            gerekmektedir.
                        </div>
                    </div>
                </>);

        //Ücretli internet paketleri ekranı
        if (information.type === 'internet_packages')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcular bu sayfada <b className="red">Ücretli İnternet Paketleri </b>görüntüleyebilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Dış Hatlar ve ER seferlerinde geçerli olan internet paketleri ile yolcular satın alım
                            yapabilir ya da kendilerine tanımlanan hakları kullanabilirler.
                            <div className="information-tab-free-table">
                                <div className="information-tab-free-table-title">ÜCRETLİ PAKETLER (DIŞ HAT ve ER)</div>
                                <table>
                                    <thead>
                                    <tr>
                                        <th>Kota</th>
                                        <th>Satış Fiyatı</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Sınırsız mesajlaşma</td>
                                        <td>3 USD</td>
                                    </tr>
                                    <tr>
                                        <td>250 MB internet</td>
                                        <td>9 USD</td>
                                    </tr>
                                    <tr>
                                        <td>500 MB internet</td>
                                        <td>15 USD</td>
                                    </tr>
                                    <tr>
                                        <td>1 GB internet</td>
                                        <td>20 USD</td>
                                    </tr>
                                    <tr>
                                        <td>Sınırsız internet ve mesajlaşma</td>
                                        <td>25 USD</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>İç Hat seferlerinde geçerli olan internet paketleri ile yolcular satın alım yapabilir
                            ya da kendilerine tanımlanan hakları kullanabilirler.
                            <div className="information-tab-free-table">
                                <div className="information-tab-free-table-title">ÜCRETLİ PAKETLER (İÇ HAT)</div>
                                <table>
                                    <thead>
                                    <tr>
                                        <th>Kota</th>
                                        <th>Satış Fiyatı</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>Sınırsız mesajlaşma paketi (YC M&amp;S üyesi ve BC misafirlerimiz hariç)
                                        </td>
                                        <td>150 TL</td>
                                    </tr>
                                    <tr>
                                        <td>Sınırsız internet paketi (BC, YC tüm misafirlerimiz)</td>
                                        <td>350 TL</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>);

        //Ücretsiz internet paketleri ekranı
        if (information.type === 'free_internet_rights')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcular bu sayfada <b className="red">Ücretsiz İnternet Paketleri </b>görüntüleyebilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Dış Hatlar ve ER seferlerinde geçerli olan ücretsiz internet paketleri ile yolcular
                            otomatik tanımlanan haklarını kullanabilirler.
                            <div className="information-tab-free-table">
                                <div className="information-tab-free-table-title">ÜCRETSİZ PAKETLER (DIŞ HAT ve ER)
                                </div>
                                <table>
                                    <thead>
                                    <tr>
                                        <th>Paket Tanımı</th>
                                        <th>Kota</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>BC Miles&amp;Smiles Elite ve Elite Plus</td>
                                        <td>Sınırsız internet</td>
                                    </tr>
                                    <tr>
                                        <td>Elite ve Elite Plus hariç, diğer BC</td>
                                        <td>1 GB internet + sınırsız mesajlaşma</td>
                                    </tr>
                                    <tr>
                                        <td>YC Miles&amp;Smiles Elite ve Elite Plus</td>
                                        <td>400 MB ve sınırsız mesajlaşma</td>
                                    </tr>
                                    <tr>
                                        <td>YC Miles&amp;Smiles Classic Plus</td>
                                        <td>250 MB ve sınırsız mesajlaşma</td>
                                    </tr>
                                    <tr>
                                        <td>YC Miles&amp;Smiles Classic</td>
                                        <td>Sınırsız mesajlaşma</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>İç Hat seferlerinde geçerli olan ücretsiz internet paketleri ile yolcular otomatik
                            tanımlanan haklarını kullanabilirler.
                            <div className="information-tab-free-table">
                                <div className="information-tab-free-table-title">ÜCRETSİZ PAKETLER (İÇ HAT)</div>
                                <table>
                                    <thead>
                                    <tr>
                                        <th>Paket Tanımı</th>
                                        <th>Kota</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>BC</td>
                                        <td>Sınırsız mesajlaşma</td>
                                    </tr>
                                    <tr>
                                        <td>YC Miles&amp;Smiles</td>
                                        <td>Sınırsız mesajlaşma</td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </>);

        //Feedback ekranına girildiğinde
        if (information.type === 'feedback')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcular bu sayfadan internet deneyimlerini ve şikayetlerini paylaşabilirler.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/> Yanıtlayabileceği alanlar
                            <div>Uçak içi internet hizmetimizi nasıl buldunuz?</div>
                            <div>İnternete bağlanma sürecini nasıl değerlendirirsiniz?</div>
                            <div>Uçak içi internet hizmetimize kayıt olma ve bağlanma sürecinizi nasıl
                                değerlendirirsiniz?
                            </div>
                            <div>Uçak içi internet hizmetimizle ilgili yorum veya önerilerinizi bize iletebilirsiniz.
                            </div>
                        </div>
                    </div>
                </>);

        //Kalan kota gösterim ekranı - Business 1 GB internet
        if (information.type === 'remaining_usage_1')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcuların sisteme giriş yaptıktan sonra karşılaştıkları ilk sayfadır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/> Yolcu bu ekran üzerinden
                            <div>Satın alınan paketleri görüntüleyebilir.</div>
                            <div>İnternetini durdurma veya başlatma yapabilir.</div>
                            <div>Çıkış yapabilir.</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu <b className="red">'Bağlantıyı durdur'</b> butonuna basarsa, tanımlı olan
                            internet paketinin kullanımı durdurulur. Böylece internet paketi tükenmez ancak yolcu
                            interneti kullanamaz.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu <b className="red">'Bağlantıyı devam ettir'</b> butonuna basarsa, tanımlı olan
                            internet paketinin kullanımı devam ettirilir. Böylece internet paketi tekrardan kullanıma
                            sunulur.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Kullanıcı çıkış yapmadan bu sayfayı kapatıp uçuş esnasında
                            tekrar <b>https://www.tkwifi.net</b> adresine giriş yaparsa otomatik olarak bu sayfa
                            açılmaktadır.
                        </div>
                    </div>
                </>);

        //Kalan kota gösterim ekranı - Hiç bir paketi olmayan kullanıcı
        if (information.type === 'remaining_usage_0')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>İlgili yolcunun <b className="red">hiçbir paketi yoksa</b> ekran bu şekilde
                            görünmektedir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcular bu ekrandan <b className="red">internet paketi satın alma</b> sayfasına
                            ilerleyebilir veya <b className="red">çıkış yapma işlemi</b> yapabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Kullanıcı çıkış yapmadan bu sayfayı kapatıp uçuş esnasında
                            tekrar <b>https://www.tkwifi.net</b> adresine giriş yaparsa otomatik olarak bu sayfa
                            açılmaktadır.
                        </div>
                    </div>
                </>);

        //PurchasePackage sayfası - İnternet ve Mesajlaşma Paketleri
        if (information.type === 'purchase_package')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu paket satın alma bölümünden iç hat ya da dış hat olarak farklı olan paketlerden
                            birini satın alım yapabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yurt içi uçuşlarında <b className="green">TL</b>, yurt dışı uçuşlarda <b
                            className="green">USD</b> para cinsi ile ödeme gerçekleşmektedir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu dilerse<b className="red"> milleri</b> ile ödeme yapabilir.
                        </div>
                    </div>
                </>);

        //Payment sayfası - Satın alma sayfası - Kredi Kartı ile
        if (information.type === 'payment_credit_card')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu internet paketi satın almak istediğinde iki farklı yöntem ile kolayca ödeme
                            yapabilir.
                            <div>Kredi kartı veya Debit kart ile ödeme</div>
                            <div>Mil ile ödeme</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu kart bilgilerini girerek internet paketi satın alıp wifi hizmetinden
                            yararlanabilir. Burada kart bilgilerin <b className="red">eksiksiz ve hatasız</b> olması
                            önemlidir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Fatura için E-posta adresi doğru bir şekilde giriş yapılmalıdır. Mesafeli satış ve ön
                            bilgilendirme formu onaylanmadan satın alma işlemi sağlanamaz.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/><b className="red">Başarılı</b> ödeme testi için;
                            <div>Ad Soyad: <b>Deneme Test</b></div>
                            <div>Kart Numarası:<b> 1234 1234 1234 1234</b></div>
                            <div>Tarih: <b>09/36</b></div>
                            <div>CVC: <b>123</b></div>
                            <div>E-Posta: <b>deneme@test.com</b></div>
                        </div>
                    </div>
                </>);

        //Payment sayfası - Satın alma sayfası - Mil ile
        if (information.type === 'payment_mil')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu internet paketi satın almak istediğinde iki farklı yöntem ile kolayca ödeme
                            yapabilir.
                            <div>Kredi kartı veya Debit kart ile ödeme</div>
                            <div>Mil ile ödeme</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu biriktirmiş olduğu milleri ile ödeme yapabilir. Burada Miles&Smiles
                            bilgilerini <b className="red">hatasız</b> olarak girmesi gerekir. Şifremi unuttum özelliği
                            bu noktada bulunmamaktadır.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Mesafeli satış ve ön bilgilendirme formu onaylanmadan satın alma işlemi sağlanamaz.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/><b className="red">Başarılı</b> ödeme testi için;
                            <div>Miles&Smiles üyelik numarası: <b>TK | 123456789</b></div>
                            <div>Şifre:<b> 123456</b></div>
                        </div>
                    </div>
                </>);

        //Payment sayfası - Satın alma sayfası - Mil ile Giriş yapılmış şekli
        if (information.type === 'payment_mil_ok')
            return (
                <>
                    <div className="information-tab-root">
                        <div className="information-tab-li-dot">
                            <span/>Yolcu internet paketi satın almak istediğinde iki farklı yöntem ile kolayca ödeme
                            yapabilir.
                            <div>Kredi kartı veya Debit kart ile ödeme</div>
                            <div>Mil ile ödeme</div>
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Yolcu biriktirmiş olduğu milleri ile ödeme yapabilir.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Miles&Smiles ile giriş yapıldığı için ekstra Miles&Smiles ile giriş yapılmasına
                            gerek yoktur.
                        </div>
                        <div className="information-tab-li-dot">
                            <span/>Mesafeli satış ve ön bilgilendirme formu onaylanmadan satın alma işlemi sağlanamaz.
                        </div>
                    </div>
                </>);

        return (<>

        </>);
    };

    return renderPage();
};

export default InformationTab;
